import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFloatingEffect from '../hooks/useFloatingEffect';

const TellFriend = () => {
  const isLoggedin = useSelector((state) => state?.userdata?.loggedIn || false);
  const myContainerRef = useRef(null);
  const sensitivityMultiplier = 0.03;

  useFloatingEffect(myContainerRef, sensitivityMultiplier);  

  return (
    <>
      <div className="surity-select-perks">
        <div className="container position-relative">
          <div className="row">
            <div className="col-lg-5 col-md-8">
              <h1>Surity Select member perks could save you $500 a year or more!</h1>
              <div className="btn-wrapper">
                {isLoggedin === true ? (
                  <Link
                    disabled={isLoggedin}
                    title="You are already logged in. Click on the profile icon to go to your dashboard."
                    className="main-btn wow zoomIn"
                    data-wow-delay="0.4s"
                  >
                    Join Now
                  </Link>
                ) : (
                  <Link to="/join-personal-info" className="main-btn wow zoomIn">
                    Join Now
                  </Link>
                )}

                <Link className="main-btn-text" to="/social-sharing">
                  Tell a friend. &gt;
                </Link>
              </div>
              <p className="future wow fadeInUp">Your future will thank you!</p>
            </div>
            <div className="col-lg-7 col-md-4">
              <div className="banner-right wow lightSpeedIn" data-wow-delay="0.5s">
                <img
                  ref={myContainerRef}
                  src="https://imgcdn.kuick.com/surity-select/join-woman-parachute.png"
                  alt=""
                  id="flyingImage"
                  width="516"
                  height="400"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TellFriend;
